import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appTableHead]',
    standalone: false
})
export class  TableHeadDirective {

  @HostBinding('class')
  className = 'app-table-head';
}
